import { CommonModule } from '@angular/common';
import { Component, computed, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { filter, map, shareReplay, switchMap } from 'rxjs/operators';
import { AppCommonModule } from 'src/app/common.module';
import { ContractorOffer } from 'src/app/models/contractor-offer.model';
import { TimestampPipe } from 'src/app/pipes/timestamp/timestamp.pipe';
import { ContractorOffersService } from 'src/app/services/contractor-offers.service';
import { SignatureService } from 'src/app/services/signature.service';
import { UserSessionService } from 'src/app/services/user-session.service';
import { Roles } from 'src/app/utility/role';
import { sortByTimestamp } from 'src/app/utility/sort';
import { ContractorOfferDialogComponent } from '../contractor-offer.dialog';

@Component({
  selector: 'app-offers',
  templateUrl: './offers.component.html',
  styleUrls: ['./offers.component.scss'],
  imports: [
    AppCommonModule,
    CommonModule,
    TimestampPipe,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [SignatureService],
})
export class OffersComponent {
  private contractorOffersService = inject(ContractorOffersService);
  private modalCtrl = inject(ModalController);
  private usersService = inject(UserSessionService);

  sub = input(false);

  offers$ = this.usersService.getCurrentUser().pipe(
    filter((user) => user != null),
    switchMap((user) => user.role === Roles.superAdmin ? this.contractorOffersService.getList({ status: 'created' }) : this.usersService.isPremiumPartner(user) ?
      this.contractorOffersService.getList({ partners: [user.guid, ...user.partners], status: 'created' }) :
      this.contractorOffersService.getList({ partner: user.guid, status: 'created' })),
    map((items) => items.sort((a, b) => sortByTimestamp(a, b, 'date'))),
    shareReplay({ bufferSize: 1, refCount: true }),
  );

  role = computed(() => this.usersService.role());

  createOffer() {
    this.modalCtrl.create({
      component: ContractorOfferDialogComponent,
      cssClass: ['workspace-modal'],
      backdropDismiss: false,
    }).then((m) => {
      m.present();
    });
  }

  onOffer(offer: ContractorOffer) {
    this.modalCtrl.create({
      component: ContractorOfferDialogComponent,
      componentProps: { item: offer },
      cssClass: ['workspace-modal'],
      backdropDismiss: false,
    }).then((m) => {
      m.present();

      m.onDidDismiss<ContractorOffer>().then((data) => {
        if (data.data) {
          const item = Object.assign({}, offer, data.data);
          this.contractorOffersService.update(item);
        }
      });
    });
  }
}
